import { AGENT_MARKET_COUNTRY } from "./agent-market-country.mjs";

export const APEX_EDITORIAL_PATH = "/apex-score";

/** One English publication. Country/language entries are transport aliases. */
export function apexEditorialRedirect(pathname) {
  if (pathname === `${APEX_EDITORIAL_PATH}/`) return APEX_EDITORIAL_PATH;
  const match = /^\/([a-z]{2})(?:\/[a-z]{2})?\/apex-score\/?$/.exec(pathname);
  return match && Object.hasOwn(AGENT_MARKET_COUNTRY, match[1])
    ? APEX_EDITORIAL_PATH : null;
}
